import * as React from "react";

import { cn } from "@/lib/utils";
import { Button } from "./button";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input flex h-9 w-full min-w-0 rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
        "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
        className
      )}
      {...props}
    />
  );
}

interface InputWithActionProps extends React.InputHTMLAttributes<HTMLInputElement> {
  icon?: React.ReactNode;
  onActionClick?: () => void;
}

function InputWithAction({
  className,
  type = "text",
  icon,
  onActionClick,
  ...props
}: InputWithActionProps) {
  return (
    <div className="relative flex w-full">
      <input
        type={type}
        data-slot="input"
        className={cn(
          "file:text-foreground placeholder:text-muted-foreground selection:bg-primary selection:text-primary-foreground dark:bg-input/30 border-input h-9 w-full rounded-md border bg-transparent px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none pr-20 md:text-sm",
          "focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]",
          "aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40 aria-invalid:border-destructive",
          className
        )}
        {...props}
      />
      <div className="absolute right-1 top-1/2 -translate-y-1/2 ">
        <Button
          type="button"
          size="sm"
          variant={"link"}
          onClick={onActionClick}
          className="hover:shadow-none"
        >
          {icon}
        </Button>
      </div>
    </div>
  );
}
export { Input, InputWithAction };
